import styled, { useTheme } from "styled-components";
import { TextContent } from "src/apps/components/typography/Texts";

import { colors } from "@permisso/permisso-components";

type Props = {
  title: string;
};

export const FormSectionHeader = ({ title }: Props) => {
  const { blackColor } = useTheme();

  return (
    <Container>
      <Title $color={blackColor}>{title}</Title>
      <Divider />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Title = styled(TextContent)<{ $color: string }>`
  font-weight: 700;
  color: ${({ $color }) => $color};
  white-space: nowrap;
  flex-shrink: 0;
`;

const Divider = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid ${colors.grey400};
  margin: 0;
`;
